import React, {ReactNode} from "react";
import {Box, Colors, Text} from "@bounce/shared/ui";

type Props = {
  title: string;
  help?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
};

const FormSection = ({title, help, action, children}: Props) => (
  <Box
    sx={{
      width: "100%",
      backgroundColor: Colors.tertiary._100,
      borderRadius: "12px",
      p: 2.5,
      display: "flex",
      flexDirection: "column",
      gap: 2,
    }}
  >
    <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 2}}>
      <Box sx={{display: "flex", flexDirection: "column", gap: 0.5}}>
        <Text variant="interDisplay600" size={16} sx={{color: Colors.grey._800}}>
          {title}
        </Text>
        {help && (
          <Text size={12} sx={{color: Colors.grey._600}}>
            {help}
          </Text>
        )}
      </Box>
      {action}
    </Box>
    {children}
  </Box>
);

export default FormSection;
